/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import { Form, Button, Modal, Table, Dropdown } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import { useTranslate } from "../hooks/LanguageProvider";
import { usePagePreferences } from "../hooks/usePagePreferences";
import { Bounce, toast } from 'react-toastify';
import ExcelJS from "exceljs";
import { PropagateLoader } from "react-spinners";

import { DownloadModal, generateExcelFile, generatePDFFile, handleDownloadConfirm, logHistory, useClipboard } from '../utilities/functions'


type Driver = {
  id_conducteur: string;
  code_conducteur: string;
  nom_conducteur: string;
  prenom_conducteur: string;
  telephone_conducteur: string;
  premis_conducteur: string;
  nom_user: string;
  prenom_user: string;
  tag: string | null;
  id_tag: string | null;
};

interface DeletedDriversItem {
  id_conducteur: string;
  nom_conducteur: string;
  prenom_conducteur: string;
  telephone_conducteur: string;
}


export function Drivers() {

  const { translate } = useTranslate();
  const [list_driver, setItems] = useState<Driver[]>([]);
  const [pageCount, setpageCount] = useState(0);
  const [showModal, setModalIsOpen] = useState(false);
  const [total, setTotal] = useState(0);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const user_id = localStorage.getItem("userid");
  const {
    preferences: listPreferences,
    setPreference: setListPreference,
    setPreferences: setListPreferences,
    loaded: listPreferencesLoaded,
  } = usePagePreferences("drivers", {
    limit: 10,
    currentPage: 1,
    searchTerm: "",
    searchType: "name",
  });
  const [limit, setLimit] = useState(Number(listPreferences.limit) || 10);
  const [currentPage, setCurrentPage] = useState(Number(listPreferences.currentPage) || 1);
  const [selectedDriverID, setSelectedDriverID] = useState<string | null>(null);
  const [deletedDriverCount, setdeletedDriverCount] = useState<number>(0);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedDrivers, setSelectedDrivers] = useState<string[]>([]);
  const [searchTerm, setSearchTerm] = useState(String(listPreferences.searchTerm || ''));
  const [searchType, setSearchType] = useState(String(listPreferences.searchType || 'name'));
  const [isDriverSelected, setIsDriverSelected] = useState(false);
  const [loadingTable, setLoadingTable] = useState<boolean>(false);
  const [initialLoad, setInitialLoad] = useState(true);
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const [deletedDrivers, setDeletedDrivers] = useState<DeletedDriversItem[]>([]);
  const [showModalDriversDeleted, setShowModalDriversDeleted] = useState(false)
  const { copyToClipboard, copiedId } = useClipboard("tag"); //
  const [showDownloadModal, setShowDownloadModal] = useState(false); // Etat pour le modal de telechargement



  const getDrivers = async (currentPage: number, limit: number) => {
    try {

      if (initialLoad) {
        setLoadingTable(true);
      }


      const total_pages = await fetch(
        `${backendUrl}/api/driver/totalpage/${user_id}?searchTerm=${searchTerm}&searchType=${searchType}`,
        { mode: 'cors' }
      );

      const totalpages = await total_pages.json();
      const total = totalpages[0].count;
      setTotal(total);

      const calculatedPageCount = Math.ceil(total / limit);
      setpageCount(calculatedPageCount);

      const res = await fetch(
        `${backendUrl}/api/driver/${user_id}?page=${currentPage}&limit=${limit}&searchTerm=${searchTerm}&searchType=${searchType}`,

        { mode: 'cors' }
      );

      const data = await res.json();
      setItems(data);
      setLoadingTable(false);

      // Marquez le chargement initial comme terminÃ©
      if (initialLoad) {
        setInitialLoad(false);
      }
    } catch (error) {
      console.error("Erreur lors du chargement des conducteurs :", error);
      setLoadingTable(false);
    }
  };
  useEffect(() => {
    if (!listPreferencesLoaded) return;

    const nextLimit = Number(listPreferences.limit) || 10;
    const nextPage = Number(listPreferences.currentPage) || 1;
    const nextSearchTerm = String(listPreferences.searchTerm || "");
    const nextSearchType = String(listPreferences.searchType || "name");

    setLimit(nextLimit);
    setCurrentPage(nextPage);
    setSearchTerm(nextSearchTerm);
    setSearchType(nextSearchType);
    getDrivers(nextPage, nextLimit);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_id, listPreferencesLoaded, listPreferences]);


  const fetchDriver = async (currentPage: number, limit: number) => {
    const res = await fetch(
      `${backendUrl}/api/driver/${user_id}?page=${currentPage}&limit=${limit}`,

      { mode: 'cors' }
    );
    const data = await res.json();
    return data;
  };

  const refreshUserData = async () => {
    getDrivers(currentPage, limit);
  };

  const fetchDeletedDrivers = async () => {
    try {
      const response = await fetch(
        `${backendUrl}/api/drivers/getDeleted/${user_id}`,
        { mode: "cors" }
      );

      if (!response.ok) {
        throw new Error(
          `Erreur lors de la rÃ©cupÃ©ration des conducteurs supprimÃ©s. Statut : ${response.status}`
        );
      }
      const data = await response.json();
      setDeletedDrivers(data);
    } catch (error) {
      console.error(
        "Erreur lors de la rÃ©cupÃ©ration des conducteurs supprimÃ©s :",
        error
      );
    }
  };

  const handleRestoreDeletedDriver = async (id_conducteur: string) => {
    try {
      const response = await fetch(
        `${backendUrl}/api/drivers/restoreDeleted/${id_conducteur}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (!response.ok) {
        throw new Error(
          `Erreur lors de la restauration du conducteurs supprimÃ©. Statut : ${response.status}`
        );
      }
      if (response.ok) {

        toast.success("Driver Restore successfully !", {
          position: "bottom-right",
          autoClose: 2400,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        try {
          const restoredDriver = deletedDrivers.find(driver => driver.id_conducteur === id_conducteur);
          if (!restoredDriver) {
            throw new Error("Driver not found in deleted drivers list");
          }

          const details = `Restore Driver: ${restoredDriver.nom_conducteur} ${restoredDriver.prenom_conducteur}`;
          await logHistory(user_id, "Restore", "Driver", "Restorer", details);
        } catch (error) {
          console.error("Erreur lors de la journalisation de l'action utilisateur :", error);
        }

        refreshUserData();
      }
      fetchDeletedDrivers();
      fetchDeletedDriverCount();
    } catch (error) {
      console.error(
        "Erreur lors de la restauration du conducteurs supprimÃ© :",
        error
      );
      toast.error("Erreur lors de la restauration du conducteurs supprimÃ©", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };


  const handlePageClick = async (data: any) => {
    const nextPage = data.selected + 1;
    const commentsFormServer = await fetchDriver(nextPage, limit);

    setItems(commentsFormServer);
    setCurrentPage(nextPage);
    setListPreference("currentPage", nextPage);
    window.scrollTo(0, 0)
  };

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };


  const handleDeleteClick = async (driverID: string) => {
    // Affichez le modal de confirmation avant la suppression
    setSelectedDriverID(driverID);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    try {
      const loggedInuser_id = localStorage.getItem("userid");

      const response = await fetch(`${backendUrl}/api/delete/${selectedDriverID}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ loggedInuser_id: loggedInuser_id }),

      });

      if (!response.ok) {
        throw new Error(`Erreur lors de la suppression logique. Statut : ${response.status}`);
      }

      const result = await response.json();

      // Fermez le modal aprÃ¨s la suppression
      setShowDeleteModal(false);

      if (response.ok) {

        toast.success("Driver Deleted successfully !", {
          position: "bottom-right",
          autoClose: 2400,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        try {
          const details = `Delete Driver:  ${list_driver.find(driver => driver.id_conducteur === selectedDriverID)?.nom_conducteur}  ${list_driver.find(driver => driver.id_conducteur === selectedDriverID)?.prenom_conducteur}`; // DÃ©tails pour le journal
          await logHistory(user_id, "Delete", "Driver", "Deleted", details);
        } catch (error) {
          console.error("Erreur lors de la journalisation de l'action utilisateur :", error);
        }
        refreshUserData();
      }

    } catch (error) {
      console.error(error);
      toast.error("Erreur Deleted conducteurs", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });

    }


  };

  // Function to handle the change in the select element
  const handleSelectChange = async (event: any) => {
    const newValue = event.target.value;
    const nextLimit = parseInt(newValue, 10);
    setLimit(nextLimit);
    setCurrentPage(1);
    setListPreferences({ limit: nextLimit, currentPage: 1 });
    const commentsFormServer = await fetchDriver(1, nextLimit);

    setItems(commentsFormServer);

  };

  const fetchDeletedDriverCount = async () => {
    try {
      const response = await fetch(
        `${backendUrl}/api/deleted-driver-count/${user_id}`,
        { mode: "cors" }
      );

      if (!response.ok) {
        throw new Error(
          `Error fetching deleted Driver count. Status: ${response.status}`
        );
      }

      const data = await response.json();
      setdeletedDriverCount(data.count);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchDeletedDriverCount(); // Fetch deleted users count on component mount
  }, [user_id]);



  // Dans la fonction handleDriverSelect
  const handleDriverSelect = (driverID: string) => {
    let updatedSelectedDrivers: string[] = [];

    // Si "SÃ©lectionner tous les conducteurs" est activÃ©e, sÃ©lectionne ou dÃ©sÃ©lectionne tous les conducteurs
    if (selectAll) {
      updatedSelectedDrivers = selectedDrivers.includes(driverID) ?
        selectedDrivers.filter(id => id !== driverID) :
        list_driver.map(driver => driver.id_conducteur);
    } else {
      // Sinon, gÃ¨re la sÃ©lection/dÃ©sÃ©lection normale des conducteurs individuels
      if (selectedDrivers.includes(driverID)) {
        updatedSelectedDrivers = selectedDrivers.filter(id => id !== driverID);
      } else {
        updatedSelectedDrivers = [...selectedDrivers, driverID];
      }
    }

    // Met Ã  jour la liste des conducteurs sÃ©lectionnÃ©s
    setSelectedDrivers(updatedSelectedDrivers);

    // Met Ã  jour l'Ã©tat isDriverSelected
    setIsDriverSelected(updatedSelectedDrivers.length > 0 || !selectAll); // Mettre Ã  jour en fonction de la sÃ©lection de tous les conducteurs

    // Met Ã  jour le conducteur sÃ©lectionnÃ© uniquement si un seul conducteur est sÃ©lectionnÃ©
    if (updatedSelectedDrivers.length === 1 && !selectAll) {
      setSelectedDriverID(driverID);
    } else {
      setSelectedDriverID(null);
    }
  };


  // Si vous souhaitez dÃ©sÃ©lectionner la case Ã  cocher globale lorsque toutes les cases individuelles sont dÃ©sÃ©lectionnÃ©es.
  useEffect(() => {
    if (selectedDrivers.length === 0) {
      setSelectAll(false);
    }
  }, [selectedDrivers]);

  // Dans la fonction handleSelectAllDrivers
  const handleSelectAllDrivers = (checked: boolean) => {
    setSelectAll(checked);
    if (checked) {
      const allDriverIDs = list_driver.map((driver) => driver.id_conducteur);
      setSelectedDrivers(allDriverIDs);
    } else {
      setSelectedDrivers([]);
    }

    // Met Ã  jour l'Ã©tat isDriverSelected
    setIsDriverSelected(checked || selectedDrivers.length > 0); // Mettre Ã  jour en fonction de la sÃ©lection de tous les conducteurs
  };


  // Function to handle the change in the input field for search
  const handleSearchTermChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const term = event.target.value;
    setSearchTerm(term);
    setCurrentPage(1);
    setListPreferences({ searchTerm: term, currentPage: 1 });

    getDrivers(1, limit);
  };
  // Fonction pour gÃ©rer le changement du type de recherche
  const handleSearchTypeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSearchType(event.target.value);
    setCurrentPage(1);
    setListPreferences({ searchType: event.target.value, currentPage: 1 });
  };

  const handleOpenDeletedDriversModal = () => {
    fetchDeletedDrivers();
    setShowModalDriversDeleted(true);
  };

  const handleCloseModel = () => {
    setShowModalDriversDeleted(false);
  };
  const clearSearchTerm = () => {
    setSearchTerm('');
    setCurrentPage(1);
    setListPreferences({ searchTerm: "", currentPage: 1 });
  };
  // Placeholder text based on search type
  let placeholderText = 'Recherche ...';
  if (searchType === 'name') {
    placeholderText = 'Recherche par nom';
  } else if (searchType === 'code') {
    placeholderText = 'Recherche par code conducteur';
  } else if (searchType === 'phone') {
    placeholderText = 'Recherche par telephone';
  } else if (searchType === 'tag') {
    placeholderText = 'Recherche par tag';
  }



  //**** Partie Excel ****
  const DriversHeaders = [
    translate("ID"),
    translate("Driver"),
    translate("Phone"),
    translate("Driver Tag"),
  ];


  const downloadDriversExcel = () => {
    const selectedData = list_driver.filter((driver) =>
      selectedDrivers.includes(driver.id_conducteur)
    ).map((driver) => [
      driver.id_conducteur,
      `${driver.nom_conducteur} ${driver.prenom_conducteur}`,
      driver.telephone_conducteur,
      driver.tag,
    ]);

    generateExcelFile("Drivers", DriversHeaders, selectedData);
  };



  const downloadDriversPDF = () => {
    const selectedData = list_driver.filter((driver) =>
      selectedDrivers.includes(driver.id_conducteur)
    ).map((driver) => [
      driver.id_conducteur,
      `${driver.nom_conducteur} ${driver.prenom_conducteur}`,
      driver.telephone_conducteur,
      driver.tag,
    ]);

    generatePDFFile("Drivers", DriversHeaders, selectedData);
  };


  const onDownloadConfirm = (format: string) => {
    if (selectedDrivers.length > 0) {
      handleDownloadConfirm(format, downloadDriversExcel, downloadDriversPDF);
    } else {
      toast.warn("Veuillez selectionner au moins un conducteur", {
        position: "bottom-right",
        autoClose: 3000,
      });
    }
  };


  return (
    <>
      <div className="row">
        <div className="col-md-6 col-sm-12">
          <h4>
            <i className="las la-user-nurse" data-rel="bootstrap-tooltip" title="Increased"></i>{translate('Drivers')} ({total})
          </h4>
        </div>
        <div className="col-md-6 col-sm-12">
          <div className="text-right">
            <Link to="/driver" className="btn btn-primary mt-2 mr-1">
              <i className="las la-plus mr-3"></i>
              {translate('New driver')}
            </Link>
            <button className="btn btn-outline-secondary mt-2 mr-1" onClick={handleOpenDeletedDriversModal}>
              <i className="las la-trash-alt" data-rel="bootstrap-tooltip" title="Increased"></i> {translate('Deleted Drivers')} ({deletedDriverCount})
            </button>
            <button
              className="btn btn-outline-secondary  mt-2 mr-1"
              onClick={() => setShowDownloadModal(true)}
            >
              <i className="las la-download"></i>
              {translate("Export")}
            </button>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-4" style={{ margin: "0px 0px 10px 0px", padding: "10px" }}>
          <div className="input-group">
            <Dropdown>
              <Dropdown.Toggle variant="link" id="dropdown-basic">
                <i className="fas fa-chevron-down" style={{ color: 'black' }}></i>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => { setSearchType('name'); setCurrentPage(1); setListPreferences({ searchType: 'name', currentPage: 1 }); }}>Nom</Dropdown.Item>
                <Dropdown.Item onClick={() => { setSearchType('code'); setCurrentPage(1); setListPreferences({ searchType: 'code', currentPage: 1 }); }}>Code conducteur</Dropdown.Item>
                <Dropdown.Item onClick={() => { setSearchType('phone'); setCurrentPage(1); setListPreferences({ searchType: 'phone', currentPage: 1 }); }}>Telephone</Dropdown.Item>
                <Dropdown.Item onClick={() => { setSearchType('tag'); setCurrentPage(1); setListPreferences({ searchType: 'tag', currentPage: 1 }); }}>Tag</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <input
              type="text"
              placeholder={placeholderText}
              className="form-control"
              onChange={handleSearchTermChange}
              value={searchTerm}
            />
            {searchTerm && (
              <button
                className="btn btn-light"
                style={{
                  border: 'none',
                  backgroundColor: '#B5C0D0',
                }}
                onClick={clearSearchTerm}
              >
                <i className="las la-times-circle" style={{ fontSize: '1.5em', color: 'black' }}></i>
              </button>
            )}
          </div>
        </div>

        <div className="col-md-8 d-flex justify-content-end align-items-center">
          <div className="dataTables_length" id="DataTables_Table_0_length">
            <label className="mr-2">
              {translate('Show')}
              <select
                name="DataTables_Table_0_length"
                aria-controls="DataTables_Table_0"
                className="custom-select custom-select-sm form-control form-control-sm ml-2"
                style={{ width: "66px" }}
                value={limit}
                onChange={handleSelectChange}
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
                <option value="500">500</option>
              </select>
              {translate('entries')}
            </label>
          </div>
        </div>
        <div className="row m-2 table-responsive" >
          <Table className="dataTable">
            <thead className="bg-white text-uppercase">
              <tr className="ligth ligth-data">
                <th className="m-0 p-0 text-center">
                  <div className="checkbox d-inline-block">
                    <input
                      className="form-check-input"
                      type="checkbox"
                        style={{ position: "relative", left: "10px" }}
                      checked={selectAll}
                      onChange={(e) => handleSelectAllDrivers(e.target.checked)}
                    />
                    <label className="mb-0"></label>
                  </div>
                </th>
                <th>{translate('Id')}</th>
                <th>{translate('Driver code')}</th>
                <th>{translate('Name')}</th>
                <th>{translate('Phone')}</th>
                <th>{translate('License category')}</th>
                <th>{translate('User')}</th>
                <th>{translate('IButton')}</th>
                <th>{translate('Actions')}</th>
              </tr>
            </thead>
            <tbody key="Drivers" className="light-body">
              {loadingTable ? (
                <tr>
                  <td colSpan={12}>
                    <div className="text-center mt-3">
                      <PropagateLoader color={"#123abc"} loading={loadingTable} size={20} />
                    </div>
                  </td>
                </tr>
              ) : list_driver.length > 0 ? (
                list_driver.map((item) => (
                  <tr key={item["id_conducteur"]} className={item["id_conducteur"]}>
                    <td className="m-0 p-0 text-center">
                      <div className="checkbox d-inline-block">
                        <input
                          type="checkbox"
                          className="form-check m-0 p-0"
                          style={{ position: "relative", top: "12px" }}
                          id={`checkbox-${item["id_conducteur"]}`}
                          checked={selectedDrivers.includes(item["id_conducteur"])}
                          onChange={() => handleDriverSelect(item["id_conducteur"])}
                        />
                        <label htmlFor={`checkbox-${item["id_conducteur"]}`} className="mb-0"></label>
                      </div>
                    </td>

                    <td>{item["id_conducteur"]}</td>
                    <td>{item["code_conducteur"]}</td>
                    <td>{`${item["nom_conducteur"]} ${item["prenom_conducteur"]}`}</td>
                    <td>{item["telephone_conducteur"]}</td>
                    <td>{item["premis_conducteur"]}</td>
                    <td>{`${item["nom_user"]} ${item["prenom_user"]}`}</td>
                    <td
                      id={`tag-${item["id_tag"]}`}
                      onClick={() => {
                        if (item["tag"] && item["id_tag"]) { // VÃ©rification pour Ã©viter les valeurs null
                          copyToClipboard(item["tag"], item["id_tag"]);
                        }
                      }} title="Cliquez pour copier le tag"
                      style={{ cursor: 'pointer', position: 'relative', color: copiedId === item["id_tag"] ? '#28a745' : '#007bff' }}
                    >
                      {item["tag"] && item["tag"] !== "Aucun" ? (
                        <>
                          <i className="las la-tags" style={{ marginRight: '4px' }}></i>
                          <span style={{ color: copiedId === item["id_tag"] ? '#28a745' : '#007bff' }}>
                            {item["tag"]}
                          </span>

                          {copiedId === item["id_tag"] && (
                            <span
                              style={{
                                position: 'absolute',
                                top: '-20px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                backgroundColor: '#28a745',
                                color: '#fff',
                                padding: '2px 5px',
                                borderRadius: '4px',
                                fontSize: '12px',
                              }}
                            >
                              Copie
                            </span>
                          )}
                        </>
                      ) : (
                        "Aucun"
                      )}
                    </td>
                    <td>
                      <div className="d-flex align-items-center list-action">
                        <Link
                          to={`/driver/${item["id_conducteur"]}`}
                          className="badge badge-success mr-2"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Modifier"
                        >
                          <i className="ri-pencil-line mr-0" style={{ fontSize: '1.2em' }}></i>
                        </Link>
                        <button
                          type="button"
                          id={item["id_conducteur"]}
                          className="badge bg-warning mr-2 border-0"
                          onClick={() => handleDeleteClick(item["id_conducteur"])}
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Delete"
                        >
                          <i className="ri-delete-bin-line mr-0" style={{ fontSize: '1.2em' }}></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={12} className="text-center">No driver available</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        <div className="row">
          <div className="col-md-6 d-flex align-items-center">
            <span>
              {translate("Displaying")} {list_driver.length} {translate("out of")}{" "}
              {total}
            </span>
          </div>
          <div className="col-md-6 d-flex justify-content-end">
            <ReactPaginate
              previousLabel={"previous"}
              nextLabel={"next"}
              breakLabel={"..."}
              pageCount={pageCount}
              forcePage={Math.max(currentPage - 1, 0)}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              containerClassName={"pagination justify-content-center"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              activeClassName={"active"}
            />
          </div>
        </div>
      </div>
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        dialogClassName="modal-90w"
        aria-labelledby=""
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontWeight: 'bold', color: 'grey' }}>{translate('Trash')}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {translate('Do you really want to remove this driver?')}
        </Modal.Body>
        <Modal.Footer className="d-flex">
          <button className="btn btn-outline-danger mt-2 mx-auto" onClick={() => setShowDeleteModal(false)}>
            {translate('Cancel')}
          </button>
          <button
            type="button"
            className="btn btn-outline-success mt-2 mx-auto"
            onClick={handleConfirmDelete}>
            {translate('Confirm')}
          </button>
        </Modal.Footer>
      </Modal>
      <Modal show={showModalDriversDeleted} onHide={handleCloseModel} centered size="lg">
        <Modal.Header closeButton >
          <Modal.Title>{translate('Deleted Drivers')}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: 'calc(80vh - 200px)', overflowY: 'auto' }}>
          <table className="table table-striped">
            <thead >
              <tr>
                <th>{translate("ID")}</th>
                <th className="text-center">{translate('Name')}</th>
                <th className="text-center">{translate('Phone')}</th>
                <th className="text-center">{translate("Actions")}</th>
              </tr>
            </thead>
            <tbody>
              {deletedDrivers.map((driver) => (
                <tr key={driver.id_conducteur}>
                  <td>{driver.id_conducteur}</td>
                  <td className="text-center">{driver.nom_conducteur} {driver.prenom_conducteur}</td>
                  <td className="text-center">{driver.telephone_conducteur}</td>
                  <td className="text-right">
                    <Button
                      variant="success"
                      onClick={() => handleRestoreDeletedDriver(driver.id_conducteur)}
                    >
                      <i className="las la-trash-restore"></i> {translate("Restore")}
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModel}>
            {translate("Close")}
          </Button>
          {/* Autres boutons ou actions si nÃ©cessaire */}
        </Modal.Footer>
      </Modal>
      {/* Le moodal est dans functions */}
      <DownloadModal
        show={showDownloadModal}
        onHide={() => setShowDownloadModal(false)}
        onDownloadConfirm={onDownloadConfirm}
      />
    </>
  );
}
